import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { theme, getStyles, filterProps } from '../../styles/theme/index.js';
import { S } from './styles.js';
import { jsx } from '@emotion/react';
import mergeDefaultProps from '../../utils/merge-default-props.js';

var _excluded = ["children", "delay", "gap", "innerJSX", "isDesktopOnly", "isDisabled", "position"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultProps = {
  gap: theme.spacing.s,
  horizontalConstraint: 'top-center',
  isDesktopOnly: false,
  isDisabled: false
};
var TooltipInternal = function TooltipInternal(props, ref) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];
  var propsInternal = mergeDefaultProps(props, defaultProps);
  var children = propsInternal.children,
      delay = propsInternal.delay;
      propsInternal.gap;
      var innerJSX = propsInternal.innerJSX,
      isDesktopOnly = propsInternal.isDesktopOnly,
      isDisabled = propsInternal.isDisabled;
      propsInternal.position;
      var rest = _objectWithoutProperties(propsInternal, _excluded);
  var wrapperRef = React.useRef(null);
  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      delayTimeout = _React$useState4[0],
      setDelayTimeout = _React$useState4[1];
  React.useImperativeHandle(ref, function () {
    return wrapperRef.current;
  });
  var handleClick = function handleClick(event) {
    var element = event.target;
    if (wrapperRef && wrapperRef.current && !wrapperRef.current.contains(element)) {
      setVisible(false);
    }
  };
  var handleMouseEnterTooltip = function handleMouseEnterTooltip() {
    if (isDisabled) {
      return;
    }
    if (delay) {
      var timeoutFunc = window.setTimeout(function () {
        setVisible(true);
      }, delay);
      setDelayTimeout(timeoutFunc);
      return;
    }
    setVisible(true);
  };
  React.useEffect(function () {
    window.addEventListener('touchstart', handleClick);
    return function () {
      return window.removeEventListener('touchstart', handleClick);
    };
  }, []);
  var propsAndState = _objectSpread({
    visible: visible
  }, propsInternal);
  return jsx("div", _extends({
    ref: wrapperRef,
    css: function css(theme) {
      return [S.container(theme, propsAndState), getStyles('container', theme, propsAndState)];
    },
    "data-testid": "tooltip-parent",
    onClick: function onClick() {
      if (!isDisabled && !isDesktopOnly) {
        delayTimeout && clearTimeout(delayTimeout);
        setVisible(true);
      }
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Escape' ? setVisible(false) : null;
    },
    onMouseEnter: handleMouseEnterTooltip,
    onMouseLeave: function onMouseLeave() {
      delayTimeout && clearTimeout(delayTimeout);
      setVisible(false);
    },
    role: "button",
    tabIndex: 0
  }, filterProps(rest)), jsx("div", {
    css: function css(theme) {
      return [S.tooltip(theme, propsAndState), getStyles('tooltip', theme, propsAndState)];
    },
    role: "complementary"
  }, innerJSX, jsx("div", {
    css: function css(theme) {
      return [S.arrow(theme, propsAndState), getStyles('arrow', theme, propsAndState)];
    }
  })), jsx("div", {
    "data-testid": "children"
  }, children));
};
var Tooltip = React.forwardRef(TooltipInternal);

export { Tooltip, TooltipInternal };
//# sourceMappingURL=tooltip.js.map
